export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z1JlFc-K.4fb8cd55.woff2";